import React, { PureComponent } from "react";
import { connect } from "react-redux";
import { Route, Redirect } from "react-router-dom";

import withStyles from "@material-ui/core/styles/withStyles";
import Typography from "@material-ui/core/Typography";
import Input from "@material-ui/core/Input";
import InputLabel from "@material-ui/core/InputLabel";
import Button from "@material-ui/core/Button";

import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import Colors from "../../constants/Colors";

import { logout } from "../../services/auth/reducer";

const styles = theme => ({
  main: {
    flex: 1,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    paddingBottom: 100
  },
  root: {
    width: "90%",
    minHeight: 500,
    marginTop: theme.spacing.unit * 3,
    alignItems: "center",
    justifyContent: "center",
    display: "flex",
    backgroundColor: "#FAFAFA",
    // backgroundColor: "#fff",
    overflowX: "auto"
  },
  button: {
    backgroundColor: Colors.pink
  }
});

const isNumber = n => {
  return !isNaN(parseFloat(n)) && isFinite(n);
};

class Recap extends PureComponent {
  state = {
    name: "",
    owner: "",
    domain: ""
  };

  logout = () => {
    this.props.logout();
  };

  render() {
    const { classes } = this.props;
    return (
      <div className={classes.main}>
        <Paper className={classes.root}>
          <Button onClick={this.logout} variant="contained" color="secondary">
            Se déconnecter
          </Button>
        </Paper>
      </div>
    );
  }
}

const mapStateToProps = state => {
  const { owner, name, domain, clientId } = state.client;
  return {
    token: state.auth.token,
    name,
    client: state.client,
    clientId
  };
};

export default connect(
  mapStateToProps,
  { logout }
)(withStyles(styles)(Recap));
